import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PageInfo } from '../distributor-info/distributor-info.component';
import { ModalResult, ModalAnswer } from '../../../shared/models/shared.model';
import { Employee } from '../../model/distributor.model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit {

  @Input() employees: Array<Employee> = [];
  @Input() employers: Array<string> = [];
  @Input() enableAdd = false;
  @Input() showLinks = false;
  @Output() onAddEmployee: EventEmitter<Employee> = new EventEmitter<Employee>();

  employeePopupVisible = false;
  employee: Employee = new Employee({
    firstName: 'Fred',
    lastName: 'Smith',
    phone: '555-111-1234',
    email: 'fsmith@gmail.com',
    previousExperience: true,
    previousEmployer: 'Texas Air',
    title: '',
    contactType: ''
  });

  employeeDetailLink = environment.employeeDetailLink;

  public page: PageInfo = <PageInfo>{
    title: 'Employees'
  };

  constructor() { }

  ngOnInit() {
  }

  addEmployee() {

    this.employeePopupVisible = true;
  }

  whenModalClose(modalResult: ModalResult) {
    if (modalResult.answer == ModalAnswer.OK) {
      // this.onAddNewDealer.emit(modalResult.data);
      this.onAddEmployee.emit(modalResult.data);
    }
    this.employeePopupVisible = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/distributor/components/employee-list/employee-list.component.ts